// removed by extract-text-webpack-plugin
module.exports = {"scrollPane":"scrollPane--7ab56"};